export const translations = {
    en: {
        items: {
            waitlist_btn: "Discover Project E8"
        },
        hero: {
            title: "Where intelligence meets human purpose",
            desc: "T-0 is a research initiative designed to give anyone full control over their AI. <br/> Our mission is to make large language models fully customizable, secure, and entirely user-owned, from data to deployment."
        },
        paper: {
            content: " T-0 introduces a comprehensive framework for user-directed artificial intelligence, designed to maximize security, adaptability, and transparency throughout the development and deployment process.<br />Rather than equating intelligence with the standalone capabilities of a large language model, T-0 conceptualizes cognition as an emergent property of the broader computational ecosystem. This includes protected long-term memory, context-aware retrieval, robust fine-tuning workflows, and incremental learning distributed across scalable clusters.<br /><br />User data is processed within a tightly secured environment that supports reproducible experimentation and complete control over hyperparameters, adaptation strategies, and evaluation protocols. Continuous learning mechanisms apply relevance scoring and drift detection to introduce new information selectively, ensuring that the system remains both adaptive and stable while maintaining coherent knowledge over time.<br /><br />Through this architecture, T-0 delivers a customizable and fully user-governed technologie for deploying open-source LLMs, enabling advanced applications across research, personal workflows, and enterprise-scale operations."
        },
        howItWorks: {
            title: "How it works",
            steps: {
                secureData: {
                    title: "Secure your data",
                    desc: "Import all your data into a fully encrypted, secure environment for safe processing."
                },
                trainModel: {
                    title: "Train your model",
                    desc: "Fine-tune an open-source LLM with your own data to make it smarter and tailored to your needs."
                },
                deployInstantly: {
                    title: "Deploy instantly",
                    desc: "Launch your customized LLM on a dedicated cluster, ready for immediate use."
                },
                continuousLearning: {
                    title: "Continuous learning",
                    desc: "Your model continuously learns from new data, staying up-to-date without any manual effort."
                }
            }
        },
        architecture: {
            title: "The architecture of intelligence",
            desc: "Intelligence is not defined solely by the capabilities of an LLM. It arises from the surrounding system: the structure and use of memory, the way information is retrieved and applied, and the integration of external resources. Together, these components enable reasoning and adaptive behavior that extends beyond the model itself.",
            desc2: "We aim to provide the best possible experience when using these models for research, personal use, or business. We believe AI can be a transformative force for humanity, helping us progress toward becoming a true “Type One” civilization."
        },
        cognitiveMemory: {
            title: "Cognitive memory",
            desc: "A fully encrypted memory system gives users exclusive access to their data. Integrated with a custom large language model, it uses a retrieval framework inspired by human memory. This allows the model to remember information persistently and retrieve it only when contextually relevant, ensuring secure and efficient access to knowledge."
        },
        controlledTraining: {
            title: "Controlled training & adaptation",
            desc: "After importing data, model training and fine-tuning can be done through a programmatic API or an integrated interface. The system supports careful dataset selection, iterative optimization, and reproducible experiments. Users can control hyperparameters, adaptation strategies, and evaluation procedures, keeping model refinement transparent, rigorous, and aligned with the end goals."
        },
        incrementalLearning: {
            title: "Incremental learning",
            desc: "When running on a distributed cluster, the model can learn continuously, adapting incrementally as new data arrives. Relevance and drift-detection mechanisms guide updates, allowing the model to evolve without losing prior knowledge. Updates happen only when new information is meaningful, maintaining stability and methodological rigor."
        },
        availableModels: {
            title: "Available models",
            moreSoon: "...and more soon.",
            listData: {
                Qwen: [
                    { name: "Qwen3-4B-Instruct-2507", categories: ["General"] },
                    { name: "Qwen3-8B-Base", categories: ["General"] },
                    { name: "Qwen3-8B", categories: ["Reasoning"] },
                    { name: "Qwen3-32B", categories: ["Advanced", "Reasoning"] },
                    { name: "Qwen3-30B-A3B-Base", categories: ["Advanced"] },
                    { name: "Qwen3-30B-A3B", categories: ["Reasoning", "Advanced"] },
                    { name: "Qwen3-30B-A3B-Instruct-2507", categories: ["Reasoning"] },
                    { name: "Qwen3-235B-A22B-Instruct-2507", categories: ["Advanced", "Reasoning"] }
                ],
                Llama: [
                    { name: "Llama-3.2-1B", categories: ["General"] },
                    { name: "Llama-3.2-3B", categories: ["Reasoning"] },
                    { name: "Llama-3.1-8B", categories: ["Reasoning"] },
                    { name: "Llama-3.1-8B-Instruct", categories: ["Reasoning"] },
                    { name: "Llama-3.1-70B", categories: ["Advanced", "Reasoning"] },
                    { name: "Llama-3.3-70B-Instruct", categories: ["Advanced", "Reasoning"] }
                ],
                "GPT-OSS": [
                    { name: "GPT-OSS-120B", categories: ["Advanced", "Reasoning"] },
                    { name: "GPT-OSS-20B", categories: ["Reasoning"] }
                ],
                DeepSeek: [
                    { name: "DeepSeek-V3.1", categories: ["Reasoning"] },
                    { name: "DeepSeek-V3.1-Base", categories: ["General"] }
                ],
                Mistral: [
                    { name: "Mistral-7B", categories: ["General", "Reasoning"] },
                    { name: "Mixtral-8x7B", categories: ["Advanced", "Reasoning"] },
                    { name: "Mixtral-8x22B", categories: ["Advanced", "Reasoning"] }
                ],
                Phi: [
                    { name: "Phi-3-mini", categories: ["General"] },
                    { name: "Phi-3-small", categories: ["General", "Reasoning"] },
                    { name: "Phi-3-medium", categories: ["Reasoning", "Advanced"] }
                ]
            }
        },
        waitlist: {
            form: {
                title: "Sign up",
                subtitle: "Join the waitlist",
                firstNamePlaceholder: "First name",
                lastNamePlaceholder: "Last name",
                emailPlaceholder: "Email",
                submitBtn: "Sign up",
                privacy: "This information will be used exclusively for the waitlist."
            },
            success: {
                title: "You're on the waitlist!",
                subtitle: "Thanks for signing up. We'll notify you by email as soon as we're live.",
                backBtn: "Back to home"
            },
            errors: {
                invalidEmail: "Please enter a valid email.",
                failedSignup: "Failed to sign up.",
                serverError: "Error connecting to server."
            },
            not_available: {
                title: "Project E8 is live!",
                subtitle: "You can sign up by clicking the button",
                sign_up: "Sign up now"
            }
        }
    },
    it: {
        items: {
            waitlist_btn: "Scopri Project E8"
        },
        hero: {
            title: "Dove l’intelligenza incontra lo scopo umano",
            desc: "T-0 è un'iniziativa di ricerca progettata per dare a chiunque il pieno controllo sulla propria AI. <br/> La nostra missione è rendere i modelli di linguaggio su larga scala completamente personalizzabili, sicuri e interamente di proprietà dell'utente, dai dati al deployment."
        },
        paper: {
            content: 'T-0 introduce un framework completo per l’intelligenza artificiale controllata dall’utente, progettato per massimizzare sicurezza, adattabilità e trasparenza in tutte le fasi di sviluppo e distribuzione.<br />Invece di equiparare l’intelligenza alla sola capacità di un modello linguistico, T-0 concettualizza la cognizione come una proprietà emergente di un ecosistema computazionale più ampio. Questo comprende memoria a lungo termine protetta, recupero contestuale, solidi workflow di fine-tuning e apprendimento incrementale distribuito su cluster scalabili.<br /><br />I dati dell’utente vengono elaborati in un ambiente altamente sicuro che supporta sperimentazioni riproducibili e il pieno controllo su iperparametri, strategie di adattamento e protocolli di valutazione. I meccanismi di apprendimento continuo applicano punteggi di rilevanza e rilevamento del drift per introdurre selettivamente nuove informazioni, garantendo che il sistema rimanga allo stesso tempo adattivo e stabile, preservando la coerenza della conoscenza nel tempo.<br /><br />Attraverso questa architettura, T-0 offre una tecnologia completamente personalizzabile e guidata dall’utente per distribuire LLM open-source, abilitando applicazioni avanzate nella ricerca, nei flussi di lavoro personali e nelle operazioni su scala aziendale.'
        },
        howItWorks: {
            title: "Come funziona",
            steps: {
                secureData: {
                    title: "Proteggi i tuoi dati",
                    desc: "Importa tutti i tuoi dati in un ambiente completamente crittografato e sicuro per un'elaborazione protetta."
                },
                trainModel: {
                    title: "Allena il tuo modello",
                    desc: "Affina un LLM open-source con i tuoi dati per renderlo più intelligente e su misura per le tue esigenze."
                },
                deployInstantly: {
                    title: "Distribuisci subito",
                    desc: "Lancia il tuo LLM personalizzato su un cluster dedicato, pronto all'uso immediato."
                },
                continuousLearning: {
                    title: "Apprendimento continuo",
                    desc: "Il tuo modello apprende continuamente dai nuovi dati, rimanendo aggiornato senza alcuno sforzo manuale."
                }
            }
        },
        architecture: {
            title: "L'architettura dell'intelligenza",
            desc: "L'intelligenza non è definita solo dalle capacità di un LLM. Deriva dal sistema circostante: la struttura e l'uso della memoria, il modo in cui le informazioni vengono recuperate e applicate e l'integrazione delle risorse esterne. Insieme, questi componenti permettono ragionamento e comportamento adattivo che vanno oltre il modello stesso.",
            desc2: "Miriamo a offrire la migliore esperienza possibile nell'utilizzo di questi modelli per ricerca, uso personale o applicazioni aziendali. Crediamo che l'IA possa essere una forza trasformativa per l'umanità, aiutandoci a progredire verso il diventare una vera civiltà di “Tipo Uno”."
        },
        cognitiveMemory: {
            title: "Memoria cognitiva",
            desc: "Un sistema di memoria completamente crittografato garantisce accesso esclusivo agli utenti. Integrato con un LLM personalizzato, utilizza un framework di recupero ispirato alla memoria umana. Questo permette al modello di ricordare informazioni in modo persistente e recuperarle solo quando rilevanti, garantendo accesso sicuro ed efficiente alla conoscenza."
        },
        controlledTraining: {
            title: "Addestramento e adattamento controllati",
            desc: "Dopo l'importazione dei dati, l'addestramento e l'affinamento del modello possono essere eseguiti tramite API o interfaccia integrata. Il sistema supporta una selezione accurata dei dataset, ottimizzazione iterativa e esperimenti riproducibili. Gli utenti possono controllare iperparametri, strategie di adattamento e procedure di valutazione, mantenendo il perfezionamento del modello trasparente, rigoroso e allineato agli obiettivi finali."
        },
        incrementalLearning: {
            title: "Apprendimento incrementale",
            desc: "Quando eseguito su un cluster distribuito, il modello può apprendere continuamente, adattandosi incrementando i parametri con l'arrivo di nuovi dati. Meccanismi di valutazione della rilevanza e rilevamento della deriva guidano gli aggiornamenti, permettendo al modello di evolvere senza perdere conoscenze precedenti. Gli aggiornamenti avvengono solo quando le nuove informazioni sono significative, garantendo stabilità e rigore metodologico."
        },
        availableModels: {
            title: "Modelli disponibili",
            moreSoon: "...e altri presto.",
            listData: {
                Qwen: [
                    { name: "Qwen3-4B-Instruct-2507", categories: ["Generale"] },
                    { name: "Qwen3-8B-Base", categories: ["Generale"] },
                    { name: "Qwen3-8B", categories: ["Ragionamento"] },
                    { name: "Qwen3-32B", categories: ["Avanzato", "Ragionamento"] },
                    { name: "Qwen3-30B-A3B-Base", categories: ["Avanzato"] },
                    { name: "Qwen3-30B-A3B", categories: ["Ragionamento", "Avanzato"] },
                    { name: "Qwen3-30B-A3B-Instruct-2507", categories: ["Ragionamento"] },
                    { name: "Qwen3-235B-A22B-Instruct-2507", categories: ["Avanzato", "Ragionamento"] }
                ],
                Llama: [
                    { name: "Llama-3.2-1B", categories: ["Generale"] },
                    { name: "Llama-3.2-3B", categories: ["Ragionamento"] },
                    { name: "Llama-3.1-8B", categories: ["Ragionamento"] },
                    { name: "Llama-3.1-8B-Instruct", categories: ["Ragionamento"] },
                    { name: "Llama-3.1-70B", categories: ["Avanzato", "Ragionamento"] },
                    { name: "Llama-3.3-70B-Instruct", categories: ["Avanzato", "Ragionamento"] }
                ],
                "GPT-OSS": [
                    { name: "GPT-OSS-120B", categories: ["Avanzato", "Ragionamento"] },
                    { name: "GPT-OSS-20B", categories: ["Ragionamento"] }
                ],
                DeepSeek: [
                    { name: "DeepSeek-V3.1", categories: ["Ragionamento"] },
                    { name: "DeepSeek-V3.1-Base", categories: ["Generale"] }
                ],
                Mistral: [
                    { name: "Mistral-7B", categories: ["Generale", "Ragionamento"] },
                    { name: "Mixtral-8x7B", categories: ["Avanzato", "Ragionamento"] },
                    { name: "Mixtral-8x22B", categories: ["Avanzato", "Ragionamento"] }
                ],
                Phi: [
                    { name: "Phi-3-mini", categories: ["Generale"] },
                    { name: "Phi-3-small", categories: ["Generale", "Ragionamento"] },
                    { name: "Phi-3-medium", categories: ["Ragionamento", "Avanzato"] }
                ]
            }
        },
        waitlist: {
            form: {
                title: "Iscriviti",
                subtitle: "Unisciti alla lista d'attesa",
                firstNamePlaceholder: "Nome",
                lastNamePlaceholder: "Cognome",
                emailPlaceholder: "Email",
                submitBtn: "Iscriviti",
                privacy: "Queste informazioni saranno utilizzate esclusivamente per la lista d’attesa."
            },
            success: {
                title: "Sei nella lista d'attesa!",
                subtitle: "Grazie per esserti iscritto. Ti informeremo via email non appena saremo attivi.",
                backBtn: "Torna alla home"
            },
            errors: {
                invalidEmail: "Inserisci un'email valida.",
                failedSignup: "Iscrizione fallita.",
                serverError: "Errore nella connessione al server."
            },
            not_available: {
                title: "Project E8 è live!",
                subtitle: "Puoi registrarti cliccando il pulsante",
                sign_up: "Registrati ora"
            }
        }
    },
    fr: {
        items: {
            waitlist_btn: "Découvrez Project E8"
        },
        hero: {
            title: "Là où l’intelligence rencontre la finalité humaine",
            desc: "T-0 est une initiative de recherche conçue pour donner à chacun un contrôle total sur son IA.<br/> Notre mission est de rendre les modèles de langage à grande échelle entièrement personnalisables, sécurisés et entièrement propriété de l'utilisateur, des données au déploiement."
        },
        paper: {
            content: 'T-0 introduit un cadre complet pour une intelligence artificielle contrôlée par l’utilisateur, conçu pour maximiser la sécurité, l’adaptabilité et la transparence tout au long du processus de développement et de déploiement.<br />Plutôt que d’assimiler l’intelligence aux seules capacités d’un modèle linguistique, T-0 conçoit la cognition comme une propriété émergente d’un écosystème computationnel plus large. Celui-ci inclut une mémoire à long terme protégée, une récupération contextuelle, des workflows de fine-tuning robustes et un apprentissage incrémental distribué sur des clusters évolutifs.<br /><br />Les données utilisateur sont traitées dans un environnement hautement sécurisé permettant des expérimentations reproductibles et un contrôle total sur les hyperparamètres, les stratégies d’adaptation et les protocoles d’évaluation. Les mécanismes d’apprentissage continu appliquent des scores de pertinence et une détection de dérive pour intégrer sélectivement de nouvelles informations, garantissant un système à la fois adaptable et stable, tout en maintenant la cohérence des connaissances dans le temps.<br /><br />Grâce à cette architecture, T-0 fournit une technologie entièrement personnalisable et gouvernée par l’utilisateur pour déployer des LLM open-source, permettant des applications avancées en recherche, workflows personnels et environnements d’entreprise.'
        },
        howItWorks: {
            title: "Comment ça fonctionne",
            steps: {
                secureData: {
                    title: "Sécurisez vos données",
                    desc: "Importez toutes vos données dans un environnement entièrement chiffré et sécurisé pour un traitement sûr."
                },
                trainModel: {
                    title: "Entraînez votre modèle",
                    desc: "Affinez un LLM open-source avec vos propres données pour le rendre plus intelligent et adapté à vos besoins."
                },
                deployInstantly: {
                    title: "Déployez instantanément",
                    desc: "Lancez votre LLM personnalisé sur un cluster dédié, prêt à l'emploi immédiatement."
                },
                continuousLearning: {
                    title: "Apprentissage continu",
                    desc: "Votre modèle apprend en continu à partir des nouvelles données, restant à jour sans aucun effort manuel."
                }
            }
        },
        architecture: {
            title: "L'architecture de l'intelligence",
            desc: "L'intelligence n'est pas définie uniquement par les capacités d'un LLM. Elle découle du système environnant : la structure et l'utilisation de la mémoire, la façon dont l'information est récupérée et appliquée, et l'intégration des ressources externes. Ensemble, ces composants permettent un raisonnement et un comportement adaptatif qui vont au-delà du modèle lui-même.",
            desc2: "Nous visons à offrir la meilleure expérience possible lors de l'utilisation de ces modèles pour la recherche, un usage personnel ou des applications professionnelles. Nous croyons que l'IA peut être une force transformative pour l'humanité, nous aidant à progresser vers une véritable civilisation de “Type Un”."
        },
        cognitiveMemory: {
            title: "Mémoire cognitive",
            desc: "Un système de mémoire entièrement chiffré donne aux utilisateurs un accès exclusif à leurs données. Intégré à un LLM personnalisé, il utilise un cadre de récupération inspiré de la mémoire humaine. Cela permet au modèle de mémoriser les informations de manière persistante et de les récupérer uniquement lorsqu'elles sont pertinentes, assurant un accès sûr et efficace au savoir."
        },
        controlledTraining: {
            title: "Entraînement et adaptation contrôlés",
            desc: "Après l'importation des données, l'entraînement et l'affinement du modèle peuvent être effectués via l'API ou l'interface intégrée. Le système prend en charge la sélection rigoureuse des ensembles de données, l'optimisation itérative et les expérimentations reproductibles. Les utilisateurs peuvent contrôler les hyperparamètres, les stratégies d'adaptation et les procédures d'évaluation, garantissant un affinage du modèle transparent, rigoureux et aligné sur les objectifs finaux."
        },
        incrementalLearning: {
            title: "Apprentissage incrémental",
            desc: "Lorsqu'il est exécuté sur un cluster distribué, le modèle peut apprendre en continu, s'adaptant progressivement aux nouvelles données. Les mécanismes d'évaluation de pertinence et de détection de dérive guident les mises à jour, permettant au modèle d'évoluer sans perdre les connaissances précédentes. Les mises à jour ne se produisent que lorsque les nouvelles informations sont significatives, garantissant stabilité et rigueur méthodologique."
        },
        availableModels: {
            title: "Modèles disponibles",
            moreSoon: "...et d'autres bientôt.",
            listData: {
                Qwen: [
                    { name: "Qwen3-4B-Instruct-2507", categories: ["Général"] },
                    { name: "Qwen3-8B-Base", categories: ["Général"] },
                    { name: "Qwen3-8B", categories: ["Raisonnement"] },
                    { name: "Qwen3-32B", categories: ["Avancé", "Raisonnement"] },
                    { name: "Qwen3-30B-A3B-Base", categories: ["Avancé"] },
                    { name: "Qwen3-30B-A3B", categories: ["Raisonnement", "Avancé"] },
                    { name: "Qwen3-30B-A3B-Instruct-2507", categories: ["Raisonnement"] },
                    { name: "Qwen3-235B-A22B-Instruct-2507", categories: ["Avancé", "Raisonnement"] }
                ],
                Llama: [
                    { name: "Llama-3.2-1B", categories: ["Général"] },
                    { name: "Llama-3.2-3B", categories: ["Raisonnement"] },
                    { name: "Llama-3.1-8B", categories: ["Raisonnement"] },
                    { name: "Llama-3.1-8B-Instruct", categories: ["Raisonnement"] },
                    { name: "Llama-3.1-70B", categories: ["Avancé", "Raisonnement"] },
                    { name: "Llama-3.3-70B-Instruct", categories: ["Avancé", "Raisonnement"] }
                ],
                "GPT-OSS": [
                    { name: "GPT-OSS-120B", categories: ["Avancé", "Raisonnement"] },
                    { name: "GPT-OSS-20B", categories: ["Raisonnement"] }
                ],
                DeepSeek: [
                    { name: "DeepSeek-V3.1", categories: ["Raisonnement"] },
                    { name: "DeepSeek-V3.1-Base", categories: ["Général"] }
                ],
                Mistral: [
                    { name: "Mistral-7B", categories: ["Général", "Raisonnement"] },
                    { name: "Mixtral-8x7B", categories: ["Avancé", "Raisonnement"] },
                    { name: "Mixtral-8x22B", categories: ["Avancé", "Raisonnement"] }
                ],
                Phi: [
                    { name: "Phi-3-mini", categories: ["Général"] },
                    { name: "Phi-3-small", categories: ["Général", "Raisonnement"] },
                    { name: "Phi-3-medium", categories: ["Raisonnement", "Avancé"] }
                ]
            }
        },
        waitlist: {
            form: {
                title: "Inscrivez-vous",
                subtitle: "Rejoignez la liste d'attente",
                firstNamePlaceholder: "Prénom",
                lastNamePlaceholder: "Nom",
                emailPlaceholder: "Email",
                submitBtn: "S'inscrire",
                privacy: "Ces informations seront utilisées exclusivement pour la liste d’attente."
            },
            success: {
                title: "Vous êtes sur la liste d'attente !",
                subtitle: "Merci pour votre inscription. Nous vous informerons par email dès que nous serons en ligne.",
                backBtn: "Retour à l'accueil"
            },
            errors: {
                invalidEmail: "Veuillez entrer un email valide.",
                failedSignup: "Échec de l'inscription.",
                serverError: "Erreur de connexion au serveur."
            },
            not_available: {
                title: "Project E8 est en ligne !",
                subtitle: "Vous pouvez vous inscrire en cliquant sur le bouton",
                sign_up: "S'inscrire maintenant"
            }
        }
    },
    de: {
        items: {
            waitlist_btn: "Entdecke Project E8"
        },
        hero: {
            title: "Wo Intelligenz auf menschlichen Zweck trifft",
            desc: "T-0 ist eine Forschungsinitiative, die jedem die volle Kontrolle über seine KI geben soll. <br/> Unsere Mission ist es, große Sprachmodelle vollständig anpassbar, sicher und vollständig nutzerbesessen zu machen – von den Daten bis zur Bereitstellung."
        },
        paper: {
            content: 'T-0 führt ein umfassendes Framework für nutzergesteuerte künstliche Intelligenz ein, das darauf ausgelegt ist, Sicherheit, Anpassungsfähigkeit und Transparenz während des gesamten Entwicklungs- und Bereitstellungsprozesses zu maximieren.<br />Anstatt Intelligenz mit den isolierten Fähigkeiten eines Sprachmodells gleichzusetzen, betrachtet T-0 Kognition als eine emergente Eigenschaft eines größeren rechnerischen Ökosystems. Dieses umfasst geschützten Langzeitspeicher, kontextbewusste Abfrage, robuste Fine-Tuning-Workflows und inkrementelles Lernen, verteilt über skalierbare Cluster.<br /><br />Nutzerdaten werden in einer stark gesicherten Umgebung verarbeitet, die reproduzierbare Experimente sowie vollständige Kontrolle über Hyperparameter, Anpassungsstrategien und Evaluierungsprotokolle ermöglicht. Mechanismen für kontinuierliches Lernen nutzen Relevanzbewertungen und Drifterkennung, um neue Informationen selektiv einzuführen, sodass das System sowohl anpassungsfähig als auch stabil bleibt und gleichzeitig Wissenskohärenz über die Zeit bewahrt.<br /><br />Durch diese Architektur bietet T-0 eine vollständig anpassbare und nutzergesteuerte Technologie zur Bereitstellung von Open-Source-LLMs, geeignet für anspruchsvolle Anwendungen in Forschung, persönlichen Workflows und unternehmensweiten Systemen.'
        },
        howItWorks: {
            title: "So funktioniert es",
            steps: {
                secureData: {
                    title: "Sichere deine Daten",
                    desc: "Importiere alle deine Daten in eine vollständig verschlüsselte, sichere Umgebung für eine geschützte Verarbeitung."
                },
                trainModel: {
                    title: "Trainiere dein Modell",
                    desc: "Feinabstimmung eines Open-Source-LLM mit deinen eigenen Daten, um es intelligenter und auf deine Bedürfnisse zugeschnitten zu machen."
                },
                deployInstantly: {
                    title: "Sofort bereitstellen",
                    desc: "Starte dein angepasstes LLM auf einem dedizierten Cluster, bereit zur sofortigen Nutzung."
                },
                continuousLearning: {
                    title: "Kontinuierliches Lernen",
                    desc: "Dein Modell lernt kontinuierlich aus neuen Daten und bleibt ohne manuellen Aufwand auf dem neuesten Stand."
                }
            }
        },
        architecture: {
            title: "Die Architektur der Intelligenz",
            desc: "Intelligenz wird nicht nur durch die Fähigkeiten eines LLM definiert. Sie entsteht aus dem umgebenden System: der Struktur und Nutzung des Gedächtnisses, der Art und Weise, wie Informationen abgerufen und angewendet werden, und der Integration externer Ressourcen. Zusammen ermöglichen diese Komponenten Denken und adaptives Verhalten, das über das Modell hinausgeht.",
            desc2: "Wir möchten die bestmögliche Erfahrung beim Einsatz dieser Modelle für Forschung, persönliche Nutzung oder geschäftliche Anwendungen bieten. Wir glauben, dass KI eine transformative Kraft für die Menschheit sein kann, die uns hilft, zu einer echten „Typ-Eins“-Zivilisation zu werden."
        },
        cognitiveMemory: {
            title: "Kognitives Gedächtnis",
            desc: "Ein vollständig verschlüsseltes Gedächtnissystem gibt Nutzern exklusiven Zugriff auf ihre Daten. Integriert mit einem maßgeschneiderten großen Sprachmodell, nutzt es ein Abrufsystem, das vom menschlichen Gedächtnis inspiriert ist. Dies ermöglicht es dem Modell, Informationen dauerhaft zu speichern und nur dann abzurufen, wenn sie kontextuell relevant sind, was einen sicheren und effizienten Wissenszugriff gewährleistet."
        },
        controlledTraining: {
            title: "Kontrolliertes Training & Anpassung",
            desc: "Nach dem Import der Daten kann das Modelltraining und die Feinabstimmung über eine programmatische API oder eine integrierte Benutzeroberfläche erfolgen. Das System unterstützt sorgfältige Datenauswahl, iterative Optimierung und reproduzierbare Experimente. Nutzer können Hyperparameter, Anpassungsstrategien und Evaluierungsverfahren steuern und die Modellverfeinerung transparent, rigoros und zielgerichtet gestalten."
        },
        incrementalLearning: {
            title: "Inkrementelles Lernen",
            desc: "Wenn es auf einem verteilten Cluster läuft, kann das Modell kontinuierlich lernen und sich schrittweise an neue Daten anpassen. Mechanismen zur Relevanzprüfung und Drift-Erkennung steuern Updates, sodass sich das Modell weiterentwickelt, ohne zuvor erlerntes Wissen zu verlieren. Updates erfolgen nur, wenn neue Informationen bedeutend sind, wodurch Stabilität und methodische Genauigkeit erhalten bleiben."
        },
        availableModels: {
            title: "Verfügbare Modelle",
            moreSoon: "...und bald mehr.",
            listData: {
                Qwen: [
                    { name: "Qwen3-4B-Instruct-2507", categories: ["Allgemein"] },
                    { name: "Qwen3-8B-Base", categories: ["Allgemein"] },
                    { name: "Qwen3-8B", categories: ["Logik"] },
                    { name: "Qwen3-32B", categories: ["Fortgeschritten", "Logik"] },
                    { name: "Qwen3-30B-A3B-Base", categories: ["Fortgeschritten"] },
                    { name: "Qwen3-30B-A3B", categories: ["Logik", "Fortgeschritten"] },
                    { name: "Qwen3-30B-A3B-Instruct-2507", categories: ["Logik"] },
                    { name: "Qwen3-235B-A22B-Instruct-2507", categories: ["Fortgeschritten", "Logik"] }
                ],
                Llama: [
                    { name: "Llama-3.2-1B", categories: ["Allgemein"] },
                    { name: "Llama-3.2-3B", categories: ["Logik"] },
                    { name: "Llama-3.1-8B", categories: ["Logik"] },
                    { name: "Llama-3.1-8B-Instruct", categories: ["Logik"] },
                    { name: "Llama-3.1-70B", categories: ["Fortgeschritten", "Logik"] },
                    { name: "Llama-3.3-70B-Instruct", categories: ["Fortgeschritten", "Logik"] }
                ],
                "GPT-OSS": [
                    { name: "GPT-OSS-120B", categories: ["Fortgeschritten", "Logik"] },
                    { name: "GPT-OSS-20B", categories: ["Logik"] }
                ],
                DeepSeek: [
                    { name: "DeepSeek-V3.1", categories: ["Logik"] },
                    { name: "DeepSeek-V3.1-Base", categories: ["Allgemein"] }
                ],
                Mistral: [
                    { name: "Mistral-7B", categories: ["Allgemein", "Logik"] },
                    { name: "Mixtral-8x7B", categories: ["Fortgeschritten", "Logik"] },
                    { name: "Mixtral-8x22B", categories: ["Fortgeschritten", "Logik"] }
                ],
                Phi: [
                    { name: "Phi-3-mini", categories: ["Allgemein"] },
                    { name: "Phi-3-small", categories: ["Allgemein", "Logik"] },
                    { name: "Phi-3-medium", categories: ["Logik", "Fortgeschritten"] }
                ]
            }
        },
        waitlist: {
            form: {
                title: "Anmelden",
                subtitle: "Zur Warteliste hinzufügen",
                firstNamePlaceholder: "Vorname",
                lastNamePlaceholder: "Nachname",
                emailPlaceholder: "E-Mail",
                submitBtn: "Anmelden",
                privacy: "Diese Informationen werden ausschließlich für die Warteliste verwendet."
            },
            success: {
                title: "Du stehst auf der Warteliste!",
                subtitle: "Danke für deine Anmeldung. Wir benachrichtigen dich per E-Mail, sobald wir live gehen.",
                backBtn: "Zurück zur Startseite"
            },
            errors: {
                invalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
                failedSignup: "Anmeldung fehlgeschlagen.",
                serverError: "Fehler bei der Verbindung zum Server."
            },
            not_available: {
                title: "Project E8 ist live!",
                subtitle: "Du kannst dich anmelden, indem du auf den Button klickst",
                sign_up: "Jetzt registrieren"
            }
        }
    },
    es: {
        items: {
            waitlist_btn: "Descubre Project E8"
        },
        hero: {
            title: "Donde la inteligencia se encuentra con el propósito humano",
            desc: "T-0 es una iniciativa de investigación diseñada para dar a cualquiera control total sobre su IA. <br/> Nuestra misión es hacer que los modelos de lenguaje grandes sean completamente personalizables, seguros y totalmente propiedad del usuario, desde los datos hasta el despliegue."
        },
        paper: {
            content: 'T-0 introduce un marco integral para la inteligencia artificial dirigida por el usuario, diseñado para maximizar la seguridad, la adaptabilidad y la transparencia a lo largo de todo el proceso de desarrollo y despliegue.<br />En lugar de equiparar la inteligencia con las capacidades aisladas de un modelo lingüístico, T-0 concibe la cognición como una propiedad emergente de un ecosistema computacional más amplio. Esto incluye memoria a largo plazo protegida, recuperación contextual, flujos de trabajo de fine-tuning sólidos y aprendizaje incremental distribuido en clústeres escalables.<br /><br />Los datos del usuario se procesan dentro de un entorno altamente protegido que permite experimentación reproducible y control total sobre hiperparámetros, estrategias de adaptación y protocolos de evaluación. Los mecanismos de aprendizaje continuo aplican puntuaciones de relevancia y detección de deriva para introducir información nueva de forma selectiva, garantizando un sistema adaptativo y estable que mantiene la coherencia del conocimiento con el tiempo.<br /><br />Con esta arquitectura, T-0 ofrece una tecnología completamente personalizable y gobernada por el usuario para desplegar LLMs de código abierto, habilitando aplicaciones avanzadas en investigación, flujos de trabajo personales y operaciones a escala empresarial.'
        },
        howItWorks: {
            title: "Cómo funciona",
            steps: {
                secureData: {
                    title: "Asegura tus datos",
                    desc: "Importa todos tus datos en un entorno completamente encriptado y seguro para un procesamiento protegido."
                },
                trainModel: {
                    title: "Entrena tu modelo",
                    desc: "Ajusta un LLM de código abierto con tus propios datos para hacerlo más inteligente y adaptado a tus necesidades."
                },
                deployInstantly: {
                    title: "Despliegue instantáneo",
                    desc: "Lanza tu LLM personalizado en un clúster dedicado, listo para usar de inmediato."
                },
                continuousLearning: {
                    title: "Aprendizaje continuo",
                    desc: "Tu modelo aprende continuamente de nuevos datos, manteniéndose actualizado sin esfuerzo manual."
                }
            }
        },
        architecture: {
            title: "La arquitectura de la inteligencia",
            desc: "La inteligencia no se define únicamente por las capacidades de un LLM. Surge del sistema circundante: la estructura y el uso de la memoria, la forma en que se recupera y aplica la información, y la integración de recursos externos. Juntos, estos componentes permiten el razonamiento y el comportamiento adaptativo que van más allá del modelo en sí.",
            desc2: "Nuestro objetivo es ofrecer la mejor experiencia posible al usar estos modelos para investigación, uso personal o aplicaciones empresariales. Creemos que la IA puede ser una fuerza transformadora para la humanidad, ayudándonos a avanzar hacia una verdadera civilización de “Tipo Uno”."
        },
        cognitiveMemory: {
            title: "Memoria cognitiva",
            desc: "Un sistema de memoria totalmente encriptado da a los usuarios acceso exclusivo a sus datos. Integrado con un modelo de lenguaje grande personalizado, utiliza un marco de recuperación inspirado en la memoria humana. Esto permite que el modelo recuerde información de forma persistente y la recupere solo cuando sea contextualmente relevante, asegurando un acceso seguro y eficiente al conocimiento."
        },
        controlledTraining: {
            title: "Entrenamiento y adaptación controlados",
            desc: "Después de importar los datos, el entrenamiento y la afinación del modelo se pueden realizar a través de una API programática o una interfaz integrada. El sistema soporta la selección cuidadosa de conjuntos de datos, la optimización iterativa y experimentos reproducibles. Los usuarios pueden controlar hiperparámetros, estrategias de adaptación y procedimientos de evaluación, manteniendo la refinación del modelo transparente, rigurosa y alineada con los objetivos finales."
        },
        incrementalLearning: {
            title: "Aprendizaje incremental",
            desc: "Cuando se ejecuta en un clúster distribuido, el modelo puede aprender continuamente, adaptándose de forma incremental a medida que llegan nuevos datos. Los mecanismos de relevancia y detección de desviaciones guían las actualizaciones, permitiendo que el modelo evolucione sin perder conocimiento previo. Las actualizaciones ocurren solo cuando la nueva información es significativa, manteniendo la estabilidad y el rigor metodológico."
        },
        availableModels: {
            title: "Modelos disponibles",
            moreSoon: "...y más pronto.",
            listData: {
                Qwen: [
                    { name: "Qwen3-4B-Instruct-2507", categories: ["General"] },
                    { name: "Qwen3-8B-Base", categories: ["General"] },
                    { name: "Qwen3-8B", categories: ["Razonamiento"] },
                    { name: "Qwen3-32B", categories: ["Avanzado", "Razonamiento"] },
                    { name: "Qwen3-30B-A3B-Base", categories: ["Avanzado"] },
                    { name: "Qwen3-30B-A3B", categories: ["Razonamiento", "Avanzado"] },
                    { name: "Qwen3-30B-A3B-Instruct-2507", categories: ["Razonamiento"] },
                    { name: "Qwen3-235B-A22B-Instruct-2507", categories: ["Avanzado", "Razonamiento"] }
                ],
                Llama: [
                    { name: "Llama-3.2-1B", categories: ["General"] },
                    { name: "Llama-3.2-3B", categories: ["Razonamiento"] },
                    { name: "Llama-3.1-8B", categories: ["Razonamiento"] },
                    { name: "Llama-3.1-8B-Instruct", categories: ["Razonamiento"] },
                    { name: "Llama-3.1-70B", categories: ["Avanzado", "Razonamiento"] },
                    { name: "Llama-3.3-70B-Instruct", categories: ["Avanzado", "Razonamiento"] }
                ],
                "GPT-OSS": [
                    { name: "GPT-OSS-120B", categories: ["Avanzado", "Razonamiento"] },
                    { name: "GPT-OSS-20B", categories: ["Razonamiento"] }
                ],
                DeepSeek: [
                    { name: "DeepSeek-V3.1", categories: ["Razonamiento"] },
                    { name: "DeepSeek-V3.1-Base", categories: ["General"] }
                ],
                Mistral: [
                    { name: "Mistral-7B", categories: ["General", "Razonamiento"] },
                    { name: "Mixtral-8x7B", categories: ["Avanzado", "Razonamiento"] },
                    { name: "Mixtral-8x22B", categories: ["Avanzado", "Razonamiento"] }
                ],
                Phi: [
                    { name: "Phi-3-mini", categories: ["General"] },
                    { name: "Phi-3-small", categories: ["General", "Razonamiento"] },
                    { name: "Phi-3-medium", categories: ["Razonamiento", "Avanzado"] }
                ]
            }
        },
        waitlist: {
            form: {
                title: "Registrarse",
                subtitle: "Unirse a la lista de espera",
                firstNamePlaceholder: "Nombre",
                lastNamePlaceholder: "Apellido",
                emailPlaceholder: "Correo electrónico",
                submitBtn: "Registrarse",
                privacy: "Esta información se utilizará exclusivamente para la lista de espera."
            },
            success: {
                title: "¡Estás en la lista de espera!",
                subtitle: "Gracias por registrarte. Te notificaremos por correo electrónico tan pronto como estemos en vivo.",
                backBtn: "Volver a inicio"
            },
            errors: {
                invalidEmail: "Por favor, ingresa un correo electrónico válido.",
                failedSignup: "Error al registrarse.",
                serverError: "Error al conectar con el servidor."
            },
            not_available: {
                title: "¡Project E8 está en vivo!",
                subtitle: "Puedes registrarte haciendo clic en el botón",
                sign_up: "Regístrate ahora"
            }
        }
    },
    sv: {
        items: {
            waitlist_btn: "Upptäck Project E8"
        },
        hero: {
            title: "Där intelligens möter mänskligt syfte",
            desc: "T-0 är ett forskningsinitiativ som är utformat för att ge vem som helst full kontroll över sin AI. <br/> Vårt uppdrag är att göra stora språkmodeller helt anpassningsbara, säkra och helt användarägda, från data till distribution."
        },
        paper: {
            content: 'T-0 introducerar ett heltäckande ramverk för användarstyrd artificiell intelligens, utformat för att maximera säkerhet, anpassningsförmåga och transparens under hela utvecklings- och distributionsprocessen.<br />I stället för att likställa intelligens med ett språkmodells isolerade förmågor, betraktar T-0 kognition som en framväxande egenskap hos ett större beräknings-ekosystem. Detta omfattar skyddat långtidsminne, kontextmedveten hämtning, robusta fine-tuning-arbetsflöden och inkrementellt lärande distribuerat över skalbara kluster.<br /><br />Användardata bearbetas i en starkt skyddad miljö som möjliggör reproducerbara experiment och full kontroll över hyperparametrar, anpassningsstrategier och utvärderingsprotokoll. Mekanismer för kontinuerligt lärande använder relevansbedömning och driftidentifiering för selektiv introduktion av ny information, vilket gör systemet både adaptivt och stabilt samtidigt som kunskapens koherens bevaras över tid.<br /><br />Genom denna arkitektur erbjuder T-0 en fullt användarstyrd och anpassningsbar teknologi för att distribuera open-source-LLM:er, lämpad för avancerade tillämpningar inom forskning, personliga arbetsflöden och företagsskala.'
        },
        howItWorks: {
            title: "Så fungerar det",
            steps: {
                secureData: {
                    title: "Säkra dina data",
                    desc: "Importera all din data till en helt krypterad och säker miljö för trygg bearbetning."
                },
                trainModel: {
                    title: "Träna din modell",
                    desc: "Finjustera en öppen källkod LLM med din egen data för att göra den smartare och skräddarsydd efter dina behov."
                },
                deployInstantly: {
                    title: "Distribuera direkt",
                    desc: "Starta din anpassade LLM på ett dedikerat kluster, redo för omedelbar användning."
                },
                continuousLearning: {
                    title: "Kontinuerligt lärande",
                    desc: "Din modell lär sig kontinuerligt från ny data och hålls uppdaterad utan manuellt arbete."
                }
            }
        },
        architecture: {
            title: "Intelligensens arkitektur",
            desc: "Intelligens definieras inte enbart av kapaciteterna hos en LLM. Den uppstår från det omgivande systemet: strukturen och användningen av minne, sättet information hämtas och tillämpas, samt integrationen av externa resurser. Tillsammans möjliggör dessa komponenter resonemang och adaptivt beteende som sträcker sig bortom modellen själv.",
            desc2: "Vi strävar efter att erbjuda den bästa möjliga upplevelsen när dessa modeller används för forskning, personligt bruk eller affärsapplikationer. Vi tror att AI kan vara en omvandlande kraft för mänskligheten och hjälpa oss att avancera mot att bli en sann “Typ Ett”-civilisation."
        },
        cognitiveMemory: {
            title: "Kognitivt minne",
            desc: "Ett helt krypterat minnessystem ger användare exklusiv åtkomst till sina data. Integrerat med en anpassad stor språkmodell använder det ett återhämtningsramverk inspirerat av mänskligt minne. Detta gör att modellen kan komma ihåg information permanent och endast hämta den när den är kontextuellt relevant, vilket säkerställer säker och effektiv kunskapsåtkomst."
        },
        controlledTraining: {
            title: "Kontrollerad träning & anpassning",
            desc: "Efter dataimport kan modellträning och finjustering utföras via ett programmerbart API eller ett integrerat gränssnitt. Systemet stödjer noggrann datasetval, iterativ optimering och reproducerbara experiment. Användare kan kontrollera hyperparametrar, anpassningsstrategier och utvärderingsprocedurer, vilket gör modellförfining transparent, rigorös och i linje med slutmålen."
        },
        incrementalLearning: {
            title: "Inkrementellt lärande",
            desc: "När den körs på ett distribuerat kluster kan modellen lära sig kontinuerligt och anpassa sig stegvis när ny data anländer. Relevans- och avvikelsedetekteringsmekanismer styr uppdateringar, vilket gör att modellen utvecklas utan att förlora tidigare kunskap. Uppdateringar sker endast när ny information är meningsfull, vilket upprätthåller stabilitet och metodologisk noggrannhet."
        },
        availableModels: {
            title: "Tillgängliga modeller",
            moreSoon: "...och fler kommer snart.",
            listData: {
                Qwen: [
                    { name: "Qwen3-4B-Instruct-2507", categories: ["Allmänt"] },
                    { name: "Qwen3-8B-Base", categories: ["Allmänt"] },
                    { name: "Qwen3-8B", categories: ["Resonemang"] },
                    { name: "Qwen3-32B", categories: ["Avancerad", "Resonemang"] },
                    { name: "Qwen3-30B-A3B-Base", categories: ["Avancerad"] },
                    { name: "Qwen3-30B-A3B", categories: ["Resonemang", "Avancerad"] },
                    { name: "Qwen3-30B-A3B-Instruct-2507", categories: ["Resonemang"] },
                    { name: "Qwen3-235B-A22B-Instruct-2507", categories: ["Avancerad", "Resonemang"] }
                ],
                Llama: [
                    { name: "Llama-3.2-1B", categories: ["Allmänt"] },
                    { name: "Llama-3.2-3B", categories: ["Resonemang"] },
                    { name: "Llama-3.1-8B", categories: ["Resonemang"] },
                    { name: "Llama-3.1-8B-Instruct", categories: ["Resonemang"] },
                    { name: "Llama-3.1-70B", categories: ["Avancerad", "Resonemang"] },
                    { name: "Llama-3.3-70B-Instruct", categories: ["Avancerad", "Resonemang"] }
                ],
                "GPT-OSS": [
                    { name: "GPT-OSS-120B", categories: ["Avancerad", "Resonemang"] },
                    { name: "GPT-OSS-20B", categories: ["Resonemang"] }
                ],
                DeepSeek: [
                    { name: "DeepSeek-V3.1", categories: ["Resonemang"] },
                    { name: "DeepSeek-V3.1-Base", categories: ["Allmänt"] }
                ],
                Mistral: [
                    { name: "Mistral-7B", categories: ["Allmänt", "Resonemang"] },
                    { name: "Mixtral-8x7B", categories: ["Avancerad", "Resonemang"] },
                    { name: "Mixtral-8x22B", categories: ["Avancerad", "Resonemang"] }
                ],
                Phi: [
                    { name: "Phi-3-mini", categories: ["Allmänt"] },
                    { name: "Phi-3-small", categories: ["Allmänt", "Resonemang"] },
                    { name: "Phi-3-medium", categories: ["Resonemang", "Avancerad"] }
                ]
            }
        },
        waitlist: {
            form: {
                title: "Registrera",
                subtitle: "Gå med i väntelistan",
                firstNamePlaceholder: "Förnamn",
                lastNamePlaceholder: "Efternamn",
                emailPlaceholder: "E-post",
                submitBtn: "Registrera",
                privacy: "Denna information kommer endast att användas för väntelistan."
            },
            success: {
                title: "Du är med på väntelistan!",
                subtitle: "Tack för att du registrerade dig. Vi meddelar dig via e-post så snart vi är live.",
                backBtn: "Tillbaka till startsidan"
            },
            errors: {
                invalidEmail: "Ange en giltig e-postadress.",
                failedSignup: "Registreringen misslyckades.",
                serverError: "Fel vid anslutning till servern."
            },
            not_available: {
                title: "Project E8 är live!",
                subtitle: "Du kan registrera dig genom att klicka på knappen",
                sign_up: "Registrera dig nu"
            }
        }
    },
    no: {
        items: {
            waitlist_btn: "Oppdag Project E8"
        },
        hero: {
            title: "Der intelligens møter menneskelig hensikt",
            desc: "T-0 er et forskningsinitiativ designet for å gi alle full kontroll over sin AI. <br/> Vårt mål er å gjøre store språkmodeller fullt tilpassbare, sikre og helt brukereide, fra data til distribusjon."
        },
        paper: {
            content: 'T-0 introduserer et omfattende rammeverk for brukerstyrt kunstig intelligens, utviklet for å maksimere sikkerhet, tilpasningsevne og transparens gjennom hele utviklings- og implementeringsprosessen.<br />I stedet for å definere intelligens ut fra et språkmodells isolerte egenskaper, ser T-0 på kognisjon som en fremvoksende egenskap i et bredere beregningsøkosystem. Dette inkluderer beskyttet langtidsminne, kontekstbevisst gjenfinning, robuste fine-tuning-prosesser og inkrementell læring distribuert på skalerbare klynger.<br /><br />Brukerdata behandles i et høysikret miljø som muliggjør reproduserbare eksperimenter og full kontroll over hyperparametere, tilpasningsstrategier og evalueringsprotokoller. Mekanismer for kontinuerlig læring benytter relevansvurdering og drift-deteksjon for selektiv innføring av ny informasjon, slik at systemet forblir både adaptivt og stabilt og opprettholder kunnskapskoherens over tid.<br /><br />Med denne arkitekturen tilbyr T-0 en fullt brukerstyrt og tilpassbar teknologi for distribusjon av open-source-LLM-er, egnet for avanserte anvendelser innen forskning, personlige arbeidsflyter og virksomhetsnivå.'
        },
        howItWorks: {
            title: "Slik fungerer det",
            steps: {
                secureData: {
                    title: "Sikre dataene dine",
                    desc: "Importer all data til et fullt kryptert og sikkert miljø for trygg behandling."
                },
                trainModel: {
                    title: "Tren modellen din",
                    desc: "Finjuster en åpen kildekode LLM med dine egne data for å gjøre den smartere og tilpasset dine behov."
                },
                deployInstantly: {
                    title: "Distribuer umiddelbart",
                    desc: "Start din tilpassede LLM på et dedikert klynge, klar til bruk med en gang."
                },
                continuousLearning: {
                    title: "Kontinuerlig læring",
                    desc: "Modellen din lærer kontinuerlig av ny data og holder seg oppdatert uten manuelt arbeid."
                }
            }
        },
        architecture: {
            title: "Intelligensens arkitektur",
            desc: "Intelligens defineres ikke kun af kapaciteterne hos en LLM. Den opstår fra det omkringliggende system: strukturen og brugen af hukommelse, måden information hentes og anvendes på, samt integrationen af eksterne ressourcer. Sammen muliggør disse komponenter ræsonnement og adaptiv adfærd, der går ud over modellen selv.",
            desc2: "Vi ønsker at give den bedst mulige oplevelse ved brug af disse modeller til forskning, personlig brug eller forretningsapplikationer. Vi tror, at AI kan være en transformerende kraft for menneskeheden og hjælpe os med at komme tættere på at blive en ægte “Type One”-civilisation."
        },
        cognitiveMemory: {
            title: "Kognitivt minne",
            desc: "Et fullt kryptert minnesystem gir brukere eksklusiv tilgang til sine data. Integrert med en tilpasset stor språkmodell, bruker det en henteramme inspirert av menneskelig hukommelse. Dette gjør at modellen kan huske informasjon permanent og hente den kun når den er kontekstuelt relevant, og sikrer trygg og effektiv tilgang til kunnskap."
        },
        controlledTraining: {
            title: "Kontrollert trening og tilpasning",
            desc: "Etter dataimport kan modelltrening og finjustering utføres via et programmerbart API eller et integrert grensesnitt. Systemet støtter nøye utvalg av datasett, iterativ optimalisering og reproduserbare eksperimenter. Brukere kan kontrollere hyperparametere, tilpasningsstrategier og evalueringsprosedyrer, og holde modellforbedring transparent, grundig og i tråd med sluttmålene."
        },
        incrementalLearning: {
            title: "Inkrementell læring",
            desc: "Når modellen kjører på et distribuert klynge, kan den lære kontinuerlig og tilpasse seg trinnvis etter hvert som ny data kommer inn. Relevans- og avvikdeteksjonsmekanismer styrer oppdateringer, slik at modellen utvikler seg uten å miste tidligere kunnskap. Oppdateringer skjer kun når ny informasjon er meningsfull, og opprettholder stabilitet og metodisk nøyaktighet."
        },
        availableModels: {
            title: "Tilgjengelige modeller",
            moreSoon: "...og flere kommer snart.",
            listData: {
                Qwen: [
                    { name: "Qwen3-4B-Instruct-2507", categories: ["Generell"] },
                    { name: "Qwen3-8B-Base", categories: ["Generell"] },
                    { name: "Qwen3-8B", categories: ["Resonnering"] },
                    { name: "Qwen3-32B", categories: ["Avansert", "Resonnering"] },
                    { name: "Qwen3-30B-A3B-Base", categories: ["Avansert"] },
                    { name: "Qwen3-30B-A3B", categories: ["Resonnering", "Avansert"] },
                    { name: "Qwen3-30B-A3B-Instruct-2507", categories: ["Resonnering"] },
                    { name: "Qwen3-235B-A22B-Instruct-2507", categories: ["Avansert", "Resonnering"] }
                ],
                Llama: [
                    { name: "Llama-3.2-1B", categories: ["Generell"] },
                    { name: "Llama-3.2-3B", categories: ["Resonnering"] },
                    { name: "Llama-3.1-8B", categories: ["Resonnering"] },
                    { name: "Llama-3.1-8B-Instruct", categories: ["Resonnering"] },
                    { name: "Llama-3.1-70B", categories: ["Avansert", "Resonnering"] },
                    { name: "Llama-3.3-70B-Instruct", categories: ["Avansert", "Resonnering"] }
                ],
                "GPT-OSS": [
                    { name: "GPT-OSS-120B", categories: ["Avansert", "Resonnering"] },
                    { name: "GPT-OSS-20B", categories: ["Resonnering"] }
                ],
                DeepSeek: [
                    { name: "DeepSeek-V3.1", categories: ["Resonnering"] },
                    { name: "DeepSeek-V3.1-Base", categories: ["Generell"] }
                ],
                Mistral: [
                    { name: "Mistral-7B", categories: ["Generell", "Resonnering"] },
                    { name: "Mixtral-8x7B", categories: ["Avansert", "Resonnering"] },
                    { name: "Mixtral-8x22B", categories: ["Avansert", "Resonnering"] }
                ],
                Phi: [
                    { name: "Phi-3-mini", categories: ["Generell"] },
                    { name: "Phi-3-small", categories: ["Generell", "Resonnering"] },
                    { name: "Phi-3-medium", categories: ["Resonnering", "Avansert"] }
                ]
            }
        },
        waitlist: {
            form: {
                title: "Registrer deg",
                subtitle: "Bli med på ventelisten",
                firstNamePlaceholder: "Fornavn",
                lastNamePlaceholder: "Etternavn",
                emailPlaceholder: "E-post",
                submitBtn: "Registrer",
                privacy: "Denne informasjonen vil kun bli brukt til ventelisten."
            },
            success: {
                title: "Du er på ventelisten!",
                subtitle: "Takk for at du registrerte deg. Vi vil varsle deg på e-post så snart vi er live.",
                backBtn: "Tilbake til startsiden"
            },
            errors: {
                invalidEmail: "Vennligst skriv inn en gyldig e-postadresse.",
                failedSignup: "Registrering mislyktes.",
                serverError: "Feil ved tilkobling til serveren."
            },
            not_available: {
                title: "Project E8 er live!",
                subtitle: "Du kan registrere deg ved å klikke på knappen",
                sign_up: "Registrer deg nå"
            }
        }
    }
};
